import React from 'react'
import * as Style from './StyleTestPart';
import * as images from './images';
import * as Comp from './Components';
const TestPart = () => {
    return (
        <Style.Section>
            <Style.RightSection>
                <Comp.Header />
                <Comp.FormCus />
            </Style.RightSection>
            {/* <Style.LeftSection>
                <Style.Images src={images.TeestOnline} />
            </Style.LeftSection> */}
        </Style.Section>
    )
}

export default TestPart